import * as paths from '../routes/paths';

/**
 * Registry of available IA agents.
 * Add new agents here as they are created.
 */
const AGENTS = [
    {
        id: 'prd',
        label: 'PRD',
        description: 'Genera documentos de requerimientos de producto (PRD) de forma asistida con inteligencia artificial.',
        icon: 'ri-draft-line',
        path: paths.PRD,
    },
];

export default AGENTS;
